import React, {useMemo} from 'react';
import {useTheme} from '../../theme';
import {BaseSpinner} from './BaseSpinner';
import {SpinnerProps} from './types';

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'Default',
  kind = 'Primary',
}) => {
  const theme = useTheme();
  const resolvedSize = useMemo(
    () =>
      size === 'Default'
        ? theme.spacing['24']
        : size === 'Small'
        ? theme.spacing['16']
        : theme.spacing['36'],
    [size, theme.spacing],
  );
  const resolvedTintColor = useMemo(() => {
    switch (kind) {
      case 'Primary':
        return theme.colors['content_mono_primary'];
      case 'Negative':
        return theme.colors['content_negative_default'];
      case 'Positive':
        return theme.colors['content_positive_default'];
      case 'Inverse':
        return theme.colors['content_mono_inverse_primary'];
    }
  }, [kind, theme.colors]);
  const resolvedColor = useMemo(() => {
    switch (kind) {
      case 'Primary':
      case 'Negative':
      case 'Positive':
        return theme.colors['border_mono_30'];
      case 'Inverse':
        return theme.colors['border_mono_inverse_10'];
    }
  }, [kind, theme.colors]);
  return (
    <BaseSpinner
      size={resolvedSize}
      color={resolvedColor}
      tintColor={resolvedTintColor}
    />
  );
};
